(() => {
  const modal = document.querySelector('[data-search-modal]');
  if (!modal) return;

  const input = modal.querySelector('[data-search-input]');
  const results = modal.querySelector('[data-search-results]');
  const enabled = modal.dataset.predictive === 'true';

  const setOpen = (open) => {
    modal.classList.toggle('is-open', open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) input?.focus();
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      setOpen(true);
    }
    if (event.target.closest('[data-search-close]') || event.target === modal) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) setOpen(false);
  });

  let timer;
  input?.addEventListener('input', () => {
    if (!enabled) return;
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) {
      if (results) results.innerHTML = '';
      return;
    }
    timer = setTimeout(() => {
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });
      fetch(`/search/suggest.json?${params}`)
        .then((r) => r.json())
        .then((data) => {
          const products = data.resources?.results?.products || [];
          if (!results) return;
          if (!products.length) {
            results.innerHTML = `<p class="empty-state">Nothing found.</p>`;
            return;
          }
          results.innerHTML = products
            .map((p) => {
              const img = p.image ? `<img src="${p.image}" alt="${(p.title || '').replace(/"/g, '&quot;')}">` : '';
              return `<a class="search-result" href="${p.url}">${img}<div><p class="search-result__title">${p.title}</p><p class="price">${p.price}</p></div></a>`;
            })
            .join('');
        })
        .catch(() => {});
    }, 220);
  });
})();
